import { projectFirestore } from '../../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

/** Must match `isSuperAdmin()` in Dashboard/firestore.rules (feedback list-all reads). */
export const TINT_BOLT_SUPER_ADMIN_UID = 'yusnvnmofVgwIx8lMYwGNgGDP593';

const state = {
  userRole: null,
  isModerator: false,
  isLoading: false,
  error: null
};

const getters = {
  isModerator: (state) => state.isModerator,
  userRole: (state) => state.userRole,
  /** True only for the account that may list all `feedback` docs per Firestore rules. */
  isTintBoltSuperAdmin: (state, _getters, rootState) =>
    rootState.currentUser?.uid === TINT_BOLT_SUPER_ADMIN_UID
};

const actions = {
  async fetchUserRole({ commit, rootState }) {
    if (!rootState.currentUser) {
      return;
    }
    
    commit('SET_LOADING', true);
    try {
      const userRef = doc(projectFirestore, 'users', rootState.currentUser.uid);
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        const userData = userDoc.data();
        const role = userData.role || 'user';
        const isModeratorRole = (role === 'admin' || role === 'moderator');
        
        commit('SET_USER_ROLE', role);
        commit('SET_IS_MODERATOR', isModeratorRole);
      } else {
        commit('SET_USER_ROLE', 'user');
        commit('SET_IS_MODERATOR', false);
      }
      commit('SET_ERROR', null);
    } catch (error) {
      commit('SET_ERROR', error.message);
      commit('SET_USER_ROLE', 'user');
      commit('SET_IS_MODERATOR', false);
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const mutations = {
  SET_LOADING(state, status) {
    state.isLoading = status;
  },
  SET_USER_ROLE(state, role) {
    state.userRole = role;
  },
  SET_IS_MODERATOR(state, status) {
    state.isModerator = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}; 